// extracted by mini-css-extract-plugin
export default {"equalWidthButtons":"currencyPercentageInput_equalWidthButtons__H4XUC"};